const usersDialog = {
  state: {
    usersOrBranState: false,
    usersOrBranQuery: {}, // 查询条件
    usersOrBranArr: [], // 组件返回页面值
    usersOrBranArr2: [], // 给组件初始值

    usersOrBranType: "1", // 单选框选中类型 0 岗位, 1 员工

    usersOrBranTypeDis: false, // 是否可改变单选框状态
    usersOrBrancanSelectBm: true, // 是否允许部门单机时间

    usersOrBranRoleState: false, // 是否根据权限，读取登录人的下属员工或岗位

    usersOrBranSqType: "" // findOrgBranchPostByCondition 空岗。。状态
  },

  mutations: {
    SET_USERSORBRANQUERY: (state, val) => {
      state.usersOrBranQuery = val;
    },
    SET_USERSORBRANSTATE: (state, val) => {
      state.usersOrBranState = val;
    },
    SET_USERSORBRANARR: (state, val) => {
      state.usersOrBranArr = JSON.parse(JSON.stringify(val));
    },
    SET_USERSORBRANARR2: (state, val) => {
      state.usersOrBranArr2 = JSON.parse(JSON.stringify(val));
    },
    SET_USERSORBRANTYPE: (state, val) => {
      state.usersOrBranType = val;
    },

    SET_USERSORBRANTYPEDIS: (state, val) => {
      state.usersOrBranTypeDis = val;
    },
    SET_USERSORBRANCANSELECTBM: (state, val) => {
      state.usersOrBrancanSelectBm = val;
    },
    SET_USERSORBRANROLESTATE: (state, val) => {
      state.usersOrBranRoleState = val;
    },
    SET_USERSORBRANSQTYPE: (state, val) => {
      state.usersOrBranSqType = val;
    }
  },

  actions: {}
};

export default usersDialog;
